export enum NewsCategoryEnum {
  TIPS = 'Tips',
  WOUW_ACTUA = '@WouwActua',
  PROBLEEM_VAN_DE_WEEK = 'Probleem van de week',
  AANKONDIGING = 'Aankondiging',
}

export interface NewsCategoryInterface {
  id?: number;
  label?: string;
  icon?: string;
  displayOrder?: number;
  isDefault?: boolean;
  showMethodIcon?: boolean;
}
